<template>
  <div class="dialog-wrap">
    <el-dialog
      title="分类选择"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="980px">
      <el-form class="search-wrap" ref="searchForm" :inline="true" :model="query">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="query.name" size="mini" placeholder="输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="产品类型" prop="type">
          <el-select style="width: 100px" v-model="query.type" size="mini" placeholder="请选择">
            <el-option
              v-for="item in filter.types"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select style="width: 100px" v-model="query.status" size="mini" placeholder="请选择">
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
          <el-button class="submit" size="mini" @click="handleFormReset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        ref="multipleTable"
        :data="results"
        tooltip-effect="dark"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="分类名称"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="type"
            label="产品类型"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              {{renderType(scope.row.type)}}
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="100"
            align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status == 1?'success':'danger'"
              >{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { productCategoryList } from '@/api/product'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    groups: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query:  {
        name: '',
        type: '',
        status: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        status: [
          {label: '全部', value: ''},
          {label: '正常', value: '1'},
          {label: '下线', value: '0'}
        ],
        types: [
          {label: '全部', value: ''},
          {label: '课程', value: 1},
          {label: '题库', value: 2},
          {label: '阅读资料', value: 3},
          {label: '实体资料', value: 4},
        ],
      },
      results: [],
      selections: [],
      countSelections: []
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val

      if (val) {
        this.fetchCategoryList()
      }
    },
    groups(val) {
      this.countSelections = val
    }
  },
  methods: {
    // 分类列表请求
    fetchCategoryList() {
      let params = {...this.query}
      productCategoryList(params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count

        this.$nextTick(this.setRowSelection)
      })
    },
    // 设置选中行
    setRowSelection() {
      if (this.results.length) {
        this.results.forEach(row => {
          if (this.groups.find(item => item.id === row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          }
        })
      }
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchCategoryList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchCategoryList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchCategoryList()
    },
    // 选择
    handleSelectionChange(val) {
      this.selections = val
      this.diffSelection()
    },
    handleSubmit() {
      this.$emit('submit', {groups: this.countSelections})
      this.handleClose()
    },
    handleClose() {
      // 检索条件重置
      this.query = {
        subject: '',
        type: '',
        status: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      }
      this.$emit('close')
    },
    // 选中项差异化计算
    diffSelection() {
      let diffs = []
      // 减
      this.countSelections.forEach((item, index) => {
        if (!this.selections.find(v => v.id === item.id)) {
          if (this.results.find(v2 => v2.id === item.id)) {
            diffs.push(item)
          }
        }
      })
      if (diffs.length) {
        this.countSelections = this.countSelections.filter(item => !diffs.find(v => v.id === item.id))
      }
      // 加
      this.selections.forEach(item => {
        if (!this.countSelections.find(v => v.id === item.id)) {
          this.countSelections.push(item)
        }
      })
    },
    renderType(type) {
      if (!type) {
        return ''
      }
      const list = this.filter.types.filter(item => item.value == type)
      if (list.length) {
        return list[0].label
      }
      return ''
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .search-wrap {
      margin-bottom: -10px;
    }
    .result {
      margin-top: 10px;
    }
    .footer {
      margin-top: 10px;
    }
  }
</style>
